const ID_REGEX = /^(?!user)[a-zA-Z]\w{3,23}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-zA-Z]).{8,24}$/;

export { ID_REGEX, EMAIL_REGEX, PWD_REGEX };